// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/forest-fire-smoke.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/forest-fire-smoke/forest-fire-smoke.js';

mount([g0]);
